import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { ShiftCashierStart } from "components"
import ShiftCashierReport from "./ShiftCashierReport"
import classes from "./index.module.scss"

const ShiftCashier = () => {
  const i18n = useTranslation()[1]

  const { _id: accountId } =
    useSelector(state => state.userAccountInfo)

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const isOpened = !!shiftCashier[accountId]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"]
      )}
    >
      {isOpened
        ? <ShiftCashierReport />
        : <ShiftCashierStart />
      }
    </div>
  )
}

export default ShiftCashier